<template>
  <div class="style-color-preview">
    <StyleColorPreviewImagePlaceholder
      :size="size"/>
    <div class="description">
      <TextPlaceholder
        v-if="descriptionLines > 0"
        variant="h6"
        :size="isMobile ? 'small' : 'medium'"/>
      <TextPlaceholder
        v-if="descriptionLines > 1"
        variant="small-text"
        :size="isMobile ? 'medium' : 'large'"/>
    </div>
  </div>
</template>

<script setup>
import useScreenSize from '@shared/composables/screenSize.js'
import StyleColorPreviewImagePlaceholder from './StyleColorPreviewImagePlaceholder.vue'
import TextPlaceholder from '@/components/global/sequin/TextPlaceholder.vue' // TODO: ENG-3647 - Isolate shared code.

defineProps({
  size: {
    type: String,
    default: 'auto',
    validator: value => ['auto', 'xx-large', 'x-large', 'large', 'medium', 'small', 'tiny'].includes(value)
  },
  descriptionLines: {
    type: Number,
    default: 2
  }
})

const { isMobile } = useScreenSize()
</script>

<style lang="scss" scoped>
@import './StyleColorPreview.scss';
</style>
